<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="general" slot-scope="{ item }">
            {{!!item.general?'General':'Especifica'}}
        </template>

        <template slot="created_at" slot-scope="{ item }">
            {{item.created_at | date}}
        </template>

        <template slot="approval_date" slot-scope="{ item }">
            {{item.approval_date | date}}
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button variant="primary" size="sm" @click="seeCard(item)"><i class="fa fa-search-plus"></i></b-button>
            <b-button variant="primary" size="sm"  @click="startUpdate(item)"><i class="fa fa-pencil" aria-hidden="true"></i></b-button> 
            <b-button variant="danger" size="sm"  @click="startRemove(item)"><i class="fa fa-trash-o" aria-hidden="true"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
    export default {
        data() {
            return {
                fields: [
                    {
                        key: 'id',
                        label: 'Código'
                    },
                    {
                        key: 'description',
                        label: 'Descripción'
                    },
                    {
                        key: 'general',
                        label: 'General / Especifica'
                    },
                    {
                        key: 'created_at',
                        label: 'Fecha de creación'
                    },
                    {
                        key: 'approval_date',
                        label: 'Fecha de aprobación'
                    },
                    {
                        key: 'client.name',
                        label: 'Cliente'
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            startUpdate: {
                type: Function,
                required: true
            },
            startRemove: {
                type: Function,
                required: true
            },
            seeCard: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
            
        },
        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }
</script>